import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: t('footer_guides'),
      links: [
        { label: t('what_is_title'), href: '/#what-is' },
        { label: t('article_spreadsheet_guide_title'), href: '/article/cssbuy-spreadsheet-guide' },
        { label: t('article_shipping_title'), href: '/#shipping' },
        { label: t('article_qc_title'), href: '/#qc' },
      ],
    },
    {
      title: t('footer_resources'),
      links: [
        { label: t('shipping_title'), href: '/#shipping' },
        { label: t('warehouse_title'), href: '/#warehouse' },
        { label: t('coupon_title'), href: '/#coupon' },
        { label: t('safety_title'), href: '/#safety' },
      ],
    },
    {
      title: t('footer_about'),
      links: [
        { label: t('footer_policy'), href: '/#policy' },
        { label: t('faq_title'), href: '/#faq' },
        { label: 'Update Log', href: '/#updates' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-semibold text-foreground-950">
                CSSBuy<span className="text-primary-500">BR</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('hero_subtitle')}
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 hover:text-primary-500 transition-colors">
                <i className="ri-global-line w-5 h-5 flex items-center justify-center" />
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60">
          <p className="text-xs text-foreground-500 text-center mb-2">
            {t('footer_disclaimer')}
          </p>
          <p className="text-xs text-foreground-400 text-center">
            {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}